import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { CheckIcon, EditCricleIcon } from "Assets/icons";
import logo from "Assets/images/logo.png";
import { replacePlaceholders } from "helpers/common";
import parse from "html-react-parser"
import { DISCIPLINE_REPORT_NAME_MAPPING } from "config/constants";

const ReportHeader = ({ initialHeading, setHeading, therapistDetails }) => {
  const [editingReportHeading, setEditingReportHeading] = useState(false);
  const [reportHeading, setReportHeading] = useState("");

  useEffect(() => {
    if (!reportHeading) {
      return;
    }

    const disciplineId = therapistDetails?.discipline_id;

    const disciplineName = DISCIPLINE_REPORT_NAME_MAPPING[disciplineId] || therapistDetails?.caseDiscipline?.name;

    let heading = replacePlaceholders(reportHeading, {
      "DISCIPLINE": `${disciplineName}`
    })

    setHeading(heading);
    setReportHeading(heading);
  }, [reportHeading, therapistDetails]);

  useEffect(() => {
    if (!initialHeading) {
      return;
    }
    setReportHeading(initialHeading);
  }, [initialHeading]);

  const handleChangeReportHeading = (e) => {
    setReportHeading(e.target.value);
  };


  return (
    <div className="top text-center">
      <div className="mb-4 imgWrp">
        <img src={logo} alt="" className="img-fluid" />
      </div>
      <div className="d-flex justify-content-center align-items-center gap-10">
        {editingReportHeading ? (
          <input
            type="text"
            className={`form-control rounded-3 bg-white h-auto`}
            value={reportHeading}
            onChange={handleChangeReportHeading}
            onPaste={handleChangeReportHeading}
          ></input>
        ) : (
          <h6 style={{ textTransform: "uppercase" }} className="m-0 py-2 fw-sbold report-title">
            {parse(reportHeading)}
          </h6>
        )}
        <span>
          {editingReportHeading ? (
            <Button
              className="rounded-circle border-0 p-1"
              variant="transparent"
              onClick={() => setEditingReportHeading(false)}
            >
              <CheckIcon />
            </Button>
          ) : (
            <Button
              className="rounded-circle shadow border-0 p-0"
              variant="transparent"
              onClick={() => setEditingReportHeading(true)}
            >
              <EditCricleIcon />
            </Button>
          )}
        </span>
      </div>
    </div>
  )
}


export default ReportHeader;